"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listNumberFormat = exports.smallRomanValue = exports.bigRomanValue = exports.bigLetterValue = exports.smallLetterValue = void 0;
const numberToWords_1 = require("./numberToWords");
/**
 * cache małych liter
 */
const SMALL_LETTERS_CACHE = [];
/**
 * cache wielkich liter
 */
const BIG_LETTERS_CACHE = [];
/**
 * cache symboli rzymskich, wielkie litery
 */
const BIG_ROMANS_CACHE = [];
/**
 * cache symboli rzymskich, małe litery
 */
const SMALL_ROMANS_CACHE = [];
/**
 * jednostki w zapisie rzymskim, wielkie litery
 */
const BIG_ROMANS_UNITS = [
    ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'],
    ['', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'],
    ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM']
];
/**
 * jednostki w zapisie rzymskim, małe litery
 */
const SMALL_ROMANS_UNITS = [
    ['', 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix'],
    ['', 'x', 'xx', 'xxx', 'xl', 'l', 'lx', 'lxx', 'lxxx', 'xc'],
    ['', 'c', 'cc', 'ccc', 'cd', 'd', 'dc', 'dcc', 'dccc', 'cm']
];
/**
 * uniwersalna funkcja do zamiany liczby na literę
 *
 * @param {number} value wartość
 * @param {number} startAsciiIndex startowy kod ASCII odpowiadający wartości 0
 * @param {string[]} cache cache wyników
 * @returns
 */
function letterValue(value, startAsciiIndex, cache) {
    if (cache[value] !== undefined) {
        return cache[value];
    }
    let result = '';
    if (value > 24) {
        let ivalue = value;
        result = '';
        while (ivalue > 0) {
            const nvalue = ivalue % 24;
            result = String.fromCharCode(nvalue + startAsciiIndex) + result;
            if (ivalue === nvalue) {
                break;
            }
            ivalue = Math.floor(ivalue / 24);
        }
    }
    else {
        result = value ? String.fromCharCode(value + startAsciiIndex) : '';
    }
    return (cache[value] = result);
}
/**
 * zamiana liczby na odpowiadającą jej małą literę
 * 1-a, 2-b ... 24-z, 25-aa, 26-ab
 *
 * @export
 * @param {number} value liczba
 * @returns {string} odpowidająca jej wartośc literowa
 */
function smallLetterValue(value) {
    return letterValue(value, 96, SMALL_LETTERS_CACHE);
}
exports.smallLetterValue = smallLetterValue;
/**
 * zamiana liczby na odpowiadającą jej wielką literę
 * 1-A, 2-B ... 24-Z, 25-AA, 26-AB
 *
 * @export
 * @param {number} value liczba
 * @returns {string} odpowidająca jej wartośc literowa
 */
function bigLetterValue(value) {
    return letterValue(value, 64, BIG_LETTERS_CACHE);
}
exports.bigLetterValue = bigLetterValue;
/**
 * uniwersalna funkcja do zamiany liczby na liczbę rzymską
 *
 * @param {number} value liczba
 * @param {string[][]} units tablica jednostek w zapisie rzymskim
 * @param {string[]} cache cache wyników
 * @returns
 */
function romanValue(value, units, cache) {
    if (cache[value] !== undefined) {
        return cache[value];
    }
    let level = 0;
    let tlevel = 10;
    let ivalue = value;
    let result = '';
    while (ivalue > 0) {
        const dvalue = ivalue % tlevel;
        result = units[level][dvalue] + result;
        if (dvalue === ivalue) {
            break;
        }
        ivalue = Math.floor(ivalue / tlevel);
        level++;
        tlevel *= 10;
    }
    return (cache[value] = result);
}
/**
 * zmiana liczy na zapis rzymski, wielkimi literami
 * 1-I, 2-II .... 10-X ...
 *
 * @export
 * @param {number} value liczba
 * @returns {string} liczba w zapisie rzymskim
 */
function bigRomanValue(value) {
    return romanValue(value, BIG_ROMANS_UNITS, BIG_ROMANS_CACHE);
}
exports.bigRomanValue = bigRomanValue;
/**
 * zmiana liczy na zapis rzymski, małymi literami
 * 1-i, 2-ii .... 10-x ...
 *
 * @export
 * @param {number} value liczba
 * @returns {string} liczba w zapisie rzymskim
 */
function smallRomanValue(value) {
    return romanValue(value, SMALL_ROMANS_UNITS, SMALL_ROMANS_CACHE);
}
exports.smallRomanValue = smallRomanValue;
/**
 * Formatuje liczbę do tekstu wyświetlanego na liście
 *
 * @export
 * @param {number} value wartośc liczbowa
 * @param {string} [type='1.'] typ formatowania
 * @returns {string} sformatowany tekst
 */
function listNumberFormat(value, type = '1.') {
    switch (type) {
        case '1':
            return value.toString();
        case '1.':
            return value + '.';
        case '1)':
            return value + ')';
        case '(1)':
            return '(' + value + ')';
        case '§':
        case '§ 1':
            return '§ ' + value;
        case '§ 1.':
            return '§ ' + value + '.';
        case 'a':
            return smallLetterValue(value);
        case 'a)':
            return smallLetterValue(value) + ')';
        case 'a.':
            return smallLetterValue(value) + '.';
        case '(a)':
            return '(' + smallLetterValue(value) + ')';
        case 'A':
            return bigLetterValue(value);
        case 'A)':
            return bigLetterValue(value) + ')';
        case 'A.':
            return bigLetterValue(value) + '.';
        case '(A)':
            return '(' + bigLetterValue(value) + ')';
        case 'i':
            return smallRomanValue(value);
        case 'i.':
            return smallRomanValue(value) + '.';
        case 'i)':
            return smallRomanValue(value) + ')';
        case '(i)':
            return '(' + smallRomanValue(value) + ')';
        case 'I':
            return bigRomanValue(value);
        case 'I)':
            return bigRomanValue(value) + ')';
        case 'I.':
            return bigRomanValue(value) + '.';
        case '(I)':
            return '(' + bigRomanValue(value) + ')';
        case 'abc':
            return (0, numberToWords_1.numberToWords)(value);
        case 'abc)':
            return (0, numberToWords_1.numberToWords)(value) + ')';
        case 'abc.':
            return (0, numberToWords_1.numberToWords)(value) + '.';
        default:
            return '*';
    }
}
exports.listNumberFormat = listNumberFormat;
//# sourceMappingURL=listNumberFormat.js.map